/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Status of a notebook session
*/
export enum NotebookSessionStatus {
  NOTEBOOK_SESSION_STATUS_STARTING = 'STARTING',
  NOTEBOOK_SESSION_STATUS_ACTIVE = 'ACTIVE',
  NOTEBOOK_SESSION_STATUS_STOPPING = 'STOPPING',
  NOTEBOOK_SESSION_STATUS_STOPPED = 'STOPPED',
  NOTEBOOK_SESSION_STATUS_FAILED = 'FAILED'
}
